import { addHours, format } from 'date-fns';

import { OperatingTime, PreOrderSetting, Week } from '~/types/common';

import * as fp from 'lodash/fp';
import addMinutes from 'date-fns/addMinutes';
import startOfDay from 'date-fns/startOfDay';

export default function checkPickMealTimeValid(
  {
    pickMealAt,
    pickMealEnd,
  }: {
    pickMealAt: Date | null;
    pickMealEnd: Date | null;
  },
  operatingTime: OperatingTime,
  preOrderSetting: PreOrderSetting,
): boolean {
  if (!fp.isDate(pickMealAt) || !fp.isDate(pickMealEnd)) {
    return false;
  }

  const now = new Date();
  const startTime = addHours(now, preOrderSetting.afterHours);
  const endTime = addHours(now, preOrderSetting.beforeHours);

  if (
    fp.lte(pickMealAt.getTime(), startTime.getTime()) ||
    fp.gte(pickMealAt.getTime(), endTime.getTime())
  ) {
    return false;
  }

  const week = format(pickMealAt, 'EEE').toUpperCase() as Week;

  const schedules = operatingTime[week];

  return schedules.some(({ start, end }) => {
    const scheduleStartTime = addMinutes(startOfDay(pickMealAt), start).getTime();
    const scheduleEndTime = addMinutes(startOfDay(pickMealAt), end).getTime();

    return (
      fp.gte(scheduleStartTime, Math.max(startTime.getTime(), pickMealAt.getTime())) &&
      fp.lte(scheduleStartTime, Math.min(endTime.getTime(), pickMealEnd.getTime(), scheduleEndTime))
    );
  });
}
